// Only the email is kept, in sessionStorage, so it disappears when the tab
// closes. Storage can be blocked by the browser, so every access is guarded.
const REMEMBERED_EMAIL_KEY = 'rememberedEmail';

export function getRememberedEmail() {
    try {
        return sessionStorage.getItem(REMEMBERED_EMAIL_KEY) || '';
    } catch (err) {
        return '';
    }
}

export function rememberEmail(email) {
    try {
        sessionStorage.setItem(REMEMBERED_EMAIL_KEY, email);
    } catch (err) {}
}

export function forgetEmail() {
    try {
        sessionStorage.removeItem(REMEMBERED_EMAIL_KEY);
    } catch (err) {}
}
